/* eslint-disable security/detect-object-injection */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import { Suspense, useContext, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { Route, Navigate, Routes, useNavigate, useLocation } from 'react-router-dom';
import AnimatedPage from '../components/Animation/AnimatedPage';
import LoginPage from '../pages/auth/LoginForm';
import { ComponentsBasedOnRole } from './_nav';
import Layout from '../components/Layout'
import SearchEmptyScreen from '../components/SearchEmptyScreen';
import ResetPassword from '../pages/auth/LoginForm/Components/ResetPassword';
import PageNotFound from '../pages/auth/LoginForm/Components/PageNotFound';
import EmailVerificationScreen from '../CommonMethods/EmailAddressVerification';
import ForgotResetPassword from '../pages/auth/LoginForm/Components/ForgotResetPassword';
import Noroute from '../components/Noroutes/Noroutes';
import { handleEditMessageSent } from '../redux/systemConfigSlice';
import CustomOverLay from '../components/CustomOverLay';

export default function NavigationRoutes(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const userType = sessionStorage.getItem('user_type');
    const rolesToMap = ComponentsBasedOnRole[userType];
    const [isAuthenticating, setIsAuthenticating] = useState(true)
    const editingUserId = useSelector((state)=>state?.systemConfigData?.editingUserId)
    const messageSent = useSelector((state)=>state?.systemConfigData?.messageSent)
    const restrictroute = useSelector(state => state?.systemConfigData?.restrict)

    useEffect(() => {
        if (sessionStorage.getItem('IdToken')) {
            setIsLoggedIn(true);
            setIsAuthenticating(false);
            if(sessionStorage.getItem('custom:is_first_time_login')==="true"){
                navigate('/reset')
            }else if(location.pathname === '/reset'){
                navigate('/profile')
            }
        }
        else {
            setIsLoggedIn(false);
            setIsAuthenticating(false)
        }
    }, [location])
    
    useEffect(()=>{
        
        const editRoutes = ['/manage-organization-users/edit-organization-user/:id','/manage-observer/edit-observer/:id','/manage-patients/edit-patient/:id','/manage-monitoring-condition-templates/add-template/:id',]
        if(!editRoutes.includes(location.pathname)&&(editingUserId!==''||messageSent===true)){
            // dispactch(handleTargetUserEditId(''))
            // dispatch(handleEditMessageSent(false))
        }
    },[location.pathname])


    return (

        <Suspense fallback={<div></div>}>{
            <>
                {isAuthenticating ? <div><CustomOverLay Active text="Loading ARCM Organization Web Application" classKey="fixed top-0 left-0 right-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center text-white"/></div> :
                    (<Routes location={location} key={location.pathname}>
                        <Route path="/email-address-verification" element={
                            <AnimatedPage>
                                <EmailVerificationScreen />
                            </AnimatedPage>
                        } />
                        {!isLoggedIn ?
                            <>
                                <Route path="/" element={
                                    <AnimatedPage><LoginPage /></AnimatedPage>} />
                                <Route path="/reset" element={
                                    <AnimatedPage>
                                        <ResetPassword />
                                    </AnimatedPage>
                                } />
                                <Route path="/reset-new-password" element={
                                    <AnimatedPage><ForgotResetPassword /></AnimatedPage>} />

                                <Route path="/404" element={
                                    <>
                                        <SearchEmptyScreen text={"404"} />
                                    </>} />
                                {/*<Route
                                path="*"
                            element={<Navigate replace to="/" />} />*/}
                                <Route
                                    path="*"
                                    element={<PageNotFound />} />

                            </>
                            :
                            <>


                                <Route path="/reset" element={
                                    <AnimatedPage>
                                        <ResetPassword />
                                    </AnimatedPage>
                                } />
                                <Route element={<Layout {...props} />}>
                                    {
                                        rolesToMap !== undefined && rolesToMap.map((nav) => (
                                            <Route
                                                path={nav.path}
                                                element={
                                                    (restrictroute === 'true' || restrictroute === true) && nav.roleKey !== 'Profile' ? (
                                                        nav.roleKey === 'UpdatePassword' ? (
                                                            React.cloneElement(nav.element, props)
                                                        ) : (
                                                            <Navigate to="/profile" />
                                                        )
                                                    ) : (
                                                        React.cloneElement(nav.element, props)
                                                    )
                                                }
                                                key={nav.path}
                                            />
                                        ))
                                    }


                                </Route>
                                <Route
                                    path="*"
                                    element={<Navigate replace to="/" />}
                                />

                            </>

                        }
                        <Route
                            path="*"
                            element={
                                <Noroute/>} 
                                
                        />
                    </Routes>
                    )}
            </>
        }</Suspense>

    );
}